import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import {
  Table,
  Dropdown,
  Modal,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
// import { ExcelRenderer } from "react-excel-renderer";
function Pickanddrop() {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [searchDistance, setSearchDistance] = useState("");
  const [forSearchUpload, setForSearchUpload] = useState([]);
  const [riderComm, setRiderComm] = useState("");
  const [tax, setTax] = useState("");
  const [cityName, setCityName] = useState("");
  const [transFee, setTransFee] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [vehicleDes, setVehicleDes] = useState("");
  const [RiderVehicleType, setRiderVehicleType] = useState([]);
  const [nameObject, setNameObject] = useState(0);
  const [catObject, setCatObject] = useState(0);
  const [pricingId, setPricingId] = useState(0);
  const [RiderVehicleCategory, setRiderVehicleCategory] = useState([]);
  // const [isToggled, setIsToggled] = useState(false);
  const [addStatus, setAddStatus] = useState(false);  

  const [deleteStatus, setDeleteStatus] = useState(false);
  // const onToggle = () => setIsToggled(!isToggled);
  const [Base_KM, setBaseKM] = useState(0);
  const [uptoBaseFare, setUptoBaseFare] = useState(0);
  const [uptoBaseDistance, setUptoBaseDistance] = useState(0);
  const [penalty, setPenalty] = useState(0);
  const [hike, setHike] = useState(0);
  const [peakMorning, setPeakMorning] = useState(0);
  const [peakEvening, setPeakEvening] = useState(0);
  const [Base_Fare, setBaseFare] = useState(0);
  const [Per_KM, setPerKM] = useState(0);
  const [type, setType] = useState(0);
  const [spinner, setSpinner] = useState(true);
  const [allPin, setAllPin] = useState([]);
  const [singlePin, setSinglePin] = useState("");
  const [uploadData, setUploadData] = useState("");
  const [singlePinArr, setSinglePinArr] = useState([]);
  const [pincode, setPincodes] = useState([]);
  const [selectedValues, setselectedValues] = useState([
    { vehicle: "", vehicleType: "" },
  ]);
  const [pricing, setpricing] = useState([]);
  const [childid, setchild] = useState([]);
  const movers = ["two-wheeler", "truck", "3 Wheeler"];
  const taxi = ["auto", "car"];
  const airport = ["car"];
  const food = ["two-wheeler"];
  const twoWheeler = ["Bike"];
  const threeWheeler = ["3 Wheeler"];
  const car = ["SUV/MUV", "Sedan", "Hatch Back"];
  const truck = ["Tata Ace", "PickUp 8ft", "Tata 407"];
  const auto = ["Auto"];
  const objectArray_3 = [{ vehicle: "Bike", vehicleType: "two-wheeler" }];
  const objectArray_4 = [{ vehicle: "3 Wheeler", vehicleType: "3 Wheeler" }];
  const objectArray_2 = [{ vehicle: "Auto", vehicleType: "auto" }];

  const objectArray = [
    { vehicle: "SUV/MUV", vehicleType: "car" },
    { vehicle: "Sedan", vehicleType: "car" },
    { vehicle: "Hatch Back", vehicleType: "car" },
  ];
  const objectArray_1 = [
    { vehicle: "Tata Ace", vehicleType: "truck" },
    { vehicle: "3 Wheeler", vehicleType: "truck" },
    { vehicle: "PickUp 8ft", vehicleType: "truck" },
    { vehicle: "Tata 407", vehicleType: "truck" },
  ];

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const addVehicle = () => {
   
    const artical = {
      VehicleType: RiderVehicleCategory,
      Name: RiderVehicleType,
      Base_KM: Base_KM,
      Base_Fare: Base_Fare,
      Per_KM: Per_KM,
      UptoBaseKM: uptoBaseDistance,
      UptoPerKM: uptoBaseFare,
      VehicleDescription: vehicleDes,
      VehicleTransactionFee: transFee,
      VehicleDiscount: discount,
      RiderCommission: riderComm,
      SearchDistance: searchDistance,
    };
    let vehicleData = {
      Vehicle: artical,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-pricing/update-pricing/${pricingId}`,
        vehicleData
      )
      .then((response) => {
        if (response.data.status) {
          swal("vehicle Updated", response.data.message, "success", {
            timer: 1000,
          });
          getAllPricing();
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  const submitHandler = () => {

    const artical = {
      VehicleType: selectedValues[0].vehicleType,
      Name: selectedValues[0].vehicle,
      Base_KM: Base_KM,
      Base_Fare: Base_Fare,
      Per_KM: Per_KM,
      UptoBaseKM: uptoBaseDistance,
      UptoPerKM: uptoBaseFare,
      VehicleDescription: vehicleDes,
      VehicleTransactionFee: transFee,
      VehicleDiscount: discount,
      RiderCommission: riderComm,
      SearchDistance: searchDistance,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-pricing/update-pricing-vehicle/${childid}`,
        artical
      )
      .then(
        (response) =>
          swal("Pricing Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          }),
        handleClose(),
        setTimeout(() => {
          getAllPricing();
        }, 2000)
      )
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  // const selection = (selectedValues) => {
  //   setselectedValues(selectedValues);
  // };
  function getAllPricing() {
    axios
      .get(Baseurl.baseurl + "/go-pricing/get-all-pricing")
      .then((response) => {
        if (response.data.pricing) {
          setpricing(response.data.pricing);
          console.log('fnfnfn',response.data.pricing)
        }
        setSpinner(false);
      });
  }
  useEffect(() => {
    getAllPricing();
  }, []);
  const deleteHandle = () => {
    axios
      .delete(Baseurl.baseurl + `/go-pricing/delete-pricing-full/${pricingId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getAllPricing();
        setShow1(false);
      });
  };
  const deletePricing = () => {
    axios({
      method: "delete",
      url: Baseurl.baseurl + `/go-pricing/delete-pricing/${pricingId}`,
      headers: {},
      data: {
        VehicleID: childid,
      },
    }).then((response) => {
      if (response.data.status) {
        swal("Deleted", response.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
      } else {
        swal("Oops", response.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }
      getAllPricing();
      setShow1(false);
    });
  };
  const updateHikes = () => {
    let vehicleData = {
      City: cityName,
      Tax: tax,
      Penalty: penalty,
      Hike: hike,
      MorningHike: peakMorning,
      EveningHike: peakEvening,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-pricing/update-pricing-hike/${pricingId}`,
        vehicleData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", { timer: 1000 });
          getAllPricing();
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow2(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  const deleteHandlevehicletype = (
    pid,
    cid,
    vehicleType1,
    update111,
    Base_KM,
    Base_Fare,
    Per_KM,
    name,
    uptoBasefare,
    uptoBaseDistance,
    Penalty,
    hike,
    morning,
    evening,
    transfee,
    desc,
    discount,
    comm,
    searchDistance
  ) => {
    if (update111 == "update") {
      setType(vehicleType1);
      handleShow();
      setselectedValues([{ vehicle: name, vehicleType: vehicleType1 }]);
      setBaseKM(Base_KM);
      setBaseFare(Base_Fare);
      setPerKM(Per_KM);
      setchild(cid);
      setUptoBaseFare(uptoBasefare);
      setUptoBaseDistance(uptoBaseDistance);
      setTransFee(transfee);
      setVehicleDes(desc);
      setDiscount(discount);
      setRiderComm(comm);
      setSearchDistance(searchDistance);
    } else if (vehicleType1 == "addnew") {
      alert("ghggf");
    } else {
    }
  };

  const selection1 = (selectedValues) => {
    setselectedValues(selectedValues);
  };
  function onChangeFile(file) {
    // ExcelRenderer(file, (err, resp) => {
    //   if (err) {
    //   } else {
    //     let newRows = [];
    //     let allpin = [];
    //     resp.rows.slice(0).map((row, index) => {
    //       if (row && row != "undefined" && row != "") {
    //         allpin.push(row[1]);
    //         newRows.push({
    //           key: index,
    //           location: row[0],
    //           pincode: row[1],
    //           state: row[2],
    //           district: row[3],
    //         });
    //       }
    //     });
    //     setAllPin(allpin);
    //     setUploadData(newRows);
    //     setForSearchUpload(newRows);
    //   }
    // });
  }
  function storePincode() {
    setSinglePinArr(
      (oldArray) => oldArray.concat(singlePin),
      () => {}
    );
    setSinglePin("");
  }
  function searchUpload(value) {
    let filteredData = [];
    forSearchUpload.map((val) => {
      let pinString = val.pincode.toString();
      if (
        val.location.toLowerCase().includes(value) ||
        pinString.includes(value)
      ) {
        filteredData.push(val);
      }
    });
    setUploadData(filteredData);
  }
  function pincodeSelect(pin) {
    setPincodes((oldArray) => oldArray.concat(pin));
  }
  function removeDuplicates(arr) {
    var counts = arr.reduce(function (counts, item) {
      counts[item] = (counts[item] || 0) + 1;
      return counts;
    }, {});
    return Object.keys(counts).reduce(function (arr, item) {
      if (counts[item] === 1) {
        arr.push(item);
      }
      if (counts[item] === 3) {
        arr.push(item);
      }
      return arr;
    }, []);
  }
  function addGeofence(val) {
    if (val == "addAll") {
      var Pincodes = {
        pincode: allPin,
      };
    } else {
      var Pincodes = {
        pincode: [...new Set(removeDuplicates(pincode))],
      };
    }
    axios
      .put(Baseurl.baseurl + `/go-pricing/add-pincode-vehicle/${childid}`, Pincodes)
      .then((response) => {
        if (response.data.status) {
          getAllPricing();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setPincodes([]);
          setUploadData("");
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow3(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function addSinglePincodeToService() {
    var Pincodes = {
      pincode: singlePinArr,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-pricing/add-pincode-vehicle/${childid}`,
        Pincodes
      )
      .then((response) => {
        if (response.data.status) {
          getAllPricing();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setUploadData("");
          setPincodes([]);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow3(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <div className="col-16">
      <Modal
            size="lg"
            show={show3}
            onHide={() => {
              setShow3(false);
            }}
          >
            <Modal.Body>
              <div className="form-group row">
              
                <div className="col-sm-4">
                  <label>
                    <strong>Choose file to upload</strong>
                  </label>

                  <input
                    className="mt-2"
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangeFile(e.target.files[0]);
                    }}
                  />
                </div>
              </div>
              <>
                  <div className="row">
                    <div className="col-sm-4 mb-4">
                      <label>
                        <strong>Enter Pincode Manually</strong>
                      </label>
                      <input
                        value={singlePin}
                        type="text"
                        className="form-control"
                        placeholder="Pincode"
                        maxLength={6}
                        onChange={(e) => setSinglePin(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-sm-2 mt-4">
                      <button
                        onClick={() => {
                          storePincode();
                        }}
                        className="btn btn-primary"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  {singlePinArr.length !== 0 && (
                    <>
                      <table>
                        <thead>
                          <th>Pincode</th>
                        </thead>
                        {singlePinArr.map((val) => {
                          return (
                            <tbody>
                              <tr>
                                <td>{val}</td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </table>
                      <button
                        className="btn btn-primary mt-4 mb-4"
                        onClick={() => {
                          addSinglePincodeToService();
                        }}
                      >
                        Update
                      </button>
                    </>
                  )}
                </>
              {uploadData && (
                <div
                  className="card mb-0"
                  style={{
                    color: "white",
                    background:
                      "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                  }}
                >
                  <div className="card-header">
                    <input
                      type="text"
                      className="form-control col-sm-4 float-right"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchUpload(e.target.value);
                      }}
                    />
                    <Button
                      variant="primary"
                      onClick={() => {
                        addGeofence("addAll");
                      }}
                    >
                      ADD ALL
                    </Button>
                  </div>
                  <div className="card-body">
                    <table className="dataTable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>
                            <strong className="text-white">Location</strong>
                          </th>
                          <th>
                            <strong className="text-white">Pincodes</strong>
                          </th>
                          <th>
                            <strong className="text-white">State</strong>
                          </th>
                          <th>
                            <strong className="text-white">Disticts</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {uploadData.map((val) => {
                          return (
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  onClick={() => pincodeSelect(val.pincode)}
                                  className="mb-3"
                                  id="checkAll"
                                  required
                                />
                              </td>
                              <td>{val.location}</td>
                              <td>{val.pincode}</td>
                              <td>{val.state}</td>
                              <td>{val.district}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              {uploadData && (
                <Button
                  variant="primary "
                  onClick={() => {
                   addGeofence("add");
                  }}
                >
                  ADD
                </Button>
              )}
            </Modal.Footer>
          </Modal>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Body>
          {deleteStatus ? (
            <h3>are you sure! want to delete Whole Price</h3>
          ) : (
            <h3>are you sure! want to delete this pricing</h3>
          )}
        </Modal.Body>
        <Modal.Footer>
          {deleteStatus ? (
            <Button variant="primary" onClick={deleteHandle}>
              Delete
            </Button>
          ) : (
            <Button variant="primary" onClick={deletePricing}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Body>
          <div className=" align-items-left">
            <div className="col-auto">
              <label>City Name</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="text"
                  className="form-control"
                  placeholder="enter city name"
                  value={cityName}
                  onChange={(e) => setCityName(e.target.value.toLowerCase())}
                />
                <div className="input-group-append">
                  <div className="input-group-text"></div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <label>Tax</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="Eg: 5%"
                  value={tax}
                  onChange={(e) => setTax(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <label>Penalty</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  defaultValue={penalty}
                  onChange={(e) => setPenalty(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">/Rs</div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <label>Hike</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="Ex. 0.3(equal to 30%)"
                  defaultValue={hike}
                  onChange={(e) => setHike(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">/From 12AM to 6AM</div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <label>Peak Hours(Morning)</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="Ex. 0.3(equal to 30%)"
                  defaultValue={peakMorning}
                  onChange={(e) => setPeakMorning(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">/From 8AM to 10AM</div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <label>Peak Hours(Evening)</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="Ex. 0.3(equal to 30%)"
                  defaultValue={peakEvening}
                  onChange={(e) => setPeakEvening(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">/From 5PM to 7PM</div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={updateHikes}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {addStatus ? (
            <div>
              <div className="row">
                <div className="col-sm-6">
                  <label>Vehicle Category</label>
                  <div className="input-group mb-1">
                    <select
                      className="form-control"
                      id="val-skill"
                      name="val-skill"
                      defaultValue={RiderVehicleCategory}
                      onChange={(event) => {
                        setRiderVehicleCategory(event.target.value);
                        if (event.target.value === "two-wheeler") {
                          setNameObject(twoWheeler);
                        } else if (event.target.value === "car") {
                          setNameObject(car);
                        } else if (event.target.value === "truck") {
                          setNameObject(truck);
                        } else if (event.target.value === "3 Wheeler") {
                          setNameObject(threeWheeler);
                        } else {
                          setNameObject(auto);
                        }
                      }}
                    >
                      <option selected="true" disabled="disabled"></option>
                      {catObject &&
                        catObject.map((val) => (
                          <option value={val}>{val}</option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Vehicle Type</label>
                  <div className="input-group mb-1">
                    <select
                      className="form-control"
                      id="val-skill"
                      name="val-skill"
                      defaultValue={RiderVehicleType}
                      onChange={(event) => {
                        setRiderVehicleType(event.target.value);
                      }}
                    >
                      <option selected="true" disabled="disabled"></option>
                      {nameObject &&
                        nameObject.map((val) => (
                          <option value={val}>{val}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Base fare</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={Base_Fare}
                      onChange={(e) => setBaseFare(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">Rs</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Base distance</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={Base_KM}
                      onChange={(e) => setBaseKM(e.target.value)}
                      maxLength={2}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">km</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Upto Fare</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={uptoBaseFare}
                      onChange={(e) => setUptoBaseFare(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">Rs</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Upto Distance</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={uptoBaseDistance}
                      onChange={(e) => setUptoBaseDistance(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">km</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Distance fare</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      defaultValue={Per_KM}
                      onChange={(e) => setPerKM(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">/km</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Transaction Fee</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      defaultValue={transFee}
                      onChange={(e) => setTransFee(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">/Rs</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Discount</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      defaultValue={discount}
                      onChange={(e) => setDiscount(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">%</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Description</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      defaultValue={vehicleDes}
                      onChange={(e) => setVehicleDes(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Rider Commission</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      className="form-control"
                      placeholder="Ex 0 to 100"
                      value={riderComm}
                      onChange={(e) => setRiderComm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Search Distance</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="in km"
                      value={searchDistance}
                      onChange={(e) => setSearchDistance(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">Km</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row ">
                <div className="col-sm-6">
                  <label>VehicleType</label>
                  <Multiselect
                    options={
                      type == "car"
                        ? objectArray
                        : type == "two-wheeler"
                        ? objectArray_3
                        : type == "auto"
                        ? objectArray_2
                        : type == "3 Wheeler"
                        ? objectArray_4
                        : objectArray_1
                    }
                    displayValue="vehicle"
                    singleSelect
                    selectedValues={[
                      {
                        vehicle: selectedValues[0].vehicle,
                        vehicleType: selectedValues[0].vehicleType,
                      },
                    ]}
                    onSelect={selection1}
                  />
                </div>
                <div className="col-sm-6">
                  <label>Description</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      defaultValue={vehicleDes}
                      onChange={(e) => setVehicleDes(e.target.value)}
                    />
                  </div>
                </div>
               
              </div>
              <div className="row mt-3">
              <div className="col-sm-6">
                  <label>Base fare</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={Base_Fare}
                      onChange={(e) => setBaseFare(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">Rs</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Base distance</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={Base_KM}
                      onChange={(e) => setBaseKM(e.target.value)}
                      maxLength={2}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">km</div>
                    </div>
                  </div>
                </div>
               
              </div>
              <div className="row mt-3">
              <div className="col-sm-6">
                  <label>Upto Fare</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={uptoBaseFare}
                      onChange={(e) => setUptoBaseFare(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">Rs</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Upto Distance</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      value={uptoBaseDistance}
                      onChange={(e) => setUptoBaseDistance(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">km</div>
                    </div>
                  </div>
                </div>
              
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Transaction Fee</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      defaultValue={transFee}
                      onChange={(e) => setTransFee(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">/Rs</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Discount</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      defaultValue={discount}
                      onChange={(e) => setDiscount(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">%</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
              <div className="col-sm-6">
                  <label>Distance fare</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="0.00"
                      defaultValue={Per_KM}
                      onChange={(e) => setPerKM(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">/km</div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <label>Rider Commission</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      className="form-control"
                      placeholder="Ex 0 to 100"
                      value={riderComm}
                      onChange={(e) => setRiderComm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <label>Search Distance</label>
                  <div className="input-group mb-2">
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      className="form-control"
                      placeholder="in km"
                      value={searchDistance}
                      onChange={(e) => setSearchDistance(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">Km</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {addStatus ? (
            <Button variant="primary" onClick={addVehicle}>
              Add Vehicle
            </Button>
          ) : (
            <Button variant="primary" onClick={submitHandler}>
              Save Changes
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <div
        className="card p-0 m-0 text-sm"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header p-3">
          <h4 className="card-title text-white" style={{fontSize:'15px'}}>Pricing List</h4>
        </div>
        <div className="card-body p-0">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table responsive id="myTable" className="text-white">
              <thead>
                <tr>
                
                  <th>
                    <strong></strong>
                  </th>
                  <th>
                    <strong> Category</strong>
                  </th>
                  <th>
                    <strong>Vehicle Type Details</strong>
                  </th>
                </tr>
              </thead>
              <tbody >
                {pricing.map((p, i) => (
                  <tr key={p._id}>
                  
                    <td className="ml-5 p-0">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="warning"
                          className="light sharp i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              setShow(true);
                              setDeleteStatus(false);
                              setAddStatus(true);
                              setBaseFare(0);
                              setBaseKM(0);
                              setUptoBaseFare(0);
                              setUptoBaseDistance(0);
                              setPerKM(0);
                              setRiderVehicleCategory("");
                              setRiderVehicleType("");
                              setVehicleDes("");
                              setTransFee(0);
                              setDiscount(0);
                              setRiderComm(0);
                              setPricingId(p._id);
                              if (p.Category == "Go_Movers") {
                                setCatObject(movers);
                              } else if (p.Category == "Go_Taxi") {
                                setCatObject(taxi);
                              }else if (p.Category == "Go_Airport") {
                                setCatObject(airport);
                              }else if (p.Category == "Go_Rentals") {
                                setCatObject(airport);
                              }  else {
                                setCatObject(food);
                              }
                            }}
                          >
                            Add Vehicle
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setShow2(true);
                              setPricingId(p._id);
                              setPenalty(p.Penalty);
                              setHike(p.Hike);
                              setPeakMorning(p.MorningHike);
                              setPeakEvening(p.EveningHike);
                              setCityName(p.City);
                              setTax(p.Tax);
                            }}
                          >
                            Update Hikes
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setShow1(true);
                              setDeleteStatus(true);
                              setPricingId(p._id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                    <td>{p.Category}</td>
                    {p.Vehicle.map((g) => {
                      return (
                        <>
                          <Table id="myTable"  className="text-white">
                            <th>
                              <strong></strong>
                            </th>
                            <th>
                              <strong>VehicleType</strong>
                            </th>
                            <th>
                              <strong>Name</strong>
                            </th>
                            <th>
                              <strong>City</strong>
                            </th>
                            <th>
                              <strong>Pincode</strong>
                            </th>
                            <th>
                              <strong>Base Fare</strong>
                            </th>
                            <th>
                              <strong>Base Distance</strong>
                            </th>
                            <th>
                              <strong>Upto Fare</strong>
                            </th>
                            <th>
                              <strong>Upto Distance</strong>
                            </th>
                            <th>
                              <strong>Distance Fare</strong>
                            </th>
                            <th>
                              <strong>Platform Charges</strong>
                            </th>
                            <th>
                              <strong>GoCash</strong>
                            </th>
                            <th>
                              <strong>Rider Commission</strong>
                            </th>
                            <th>
                              <strong>Search Distance</strong>
                            </th>
                            <th>
                              <strong>Description</strong>
                            </th>
                           
                            <th>
                              <strong>Tax</strong>
                            </th>
                            <th>
                              <strong>Penalty</strong>
                            </th>
                            <th>
                              <strong>Hike</strong>
                            </th>
                            <th>
                              <strong>Peak Hours(Morning)</strong>
                            </th>
                            <th>
                              <strong>Peak Hours(Evening)</strong>
                            </th>

                            <tr>
                              <td>
                                {" "}
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="warning"
                                    className="light sharp i-false"
                                  >
                                    {svg1}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setAddStatus(false);
                                        setDeleteStatus(false);

                                        deleteHandlevehicletype(
                                          p._id,
                                          g._id,
                                          g.VehicleType,
                                          "update",
                                          g.Base_KM,
                                          g.Base_Fare,
                                          g.Per_KM,
                                          g.Name,
                                          g.UptoPerKM,
                                          g.UptoBaseKM,
                                          p.Penalty,
                                          p.Hike,
                                          p.MorningHike,
                                          p.EveningHike,
                                          g.VehicleTransactionFee,
                                          g.VehicleDescription,
                                          g.VehicleDiscount,
                                          g.RiderCommission,
                                          g.SearchDistance
                                        );
                                      }}
                                    >
                                      Update
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setShow3(true);
                                        setchild(g._id);
                                      }}
                                    >
                                      Add Pincode
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setShow1(true);
                                        setDeleteStatus(false);
                                        setPricingId(p._id);
                                        setchild(g._id);
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                              <td>{g.VehicleType}</td>
                              <td> {g.Name}</td>
                              <td>{p.City&&p.City.map((val)=>{
                                return(
                                  <div>{val}</div>
                                )
                              })}</td>
                                 <td> {g.Pincode.length===0?"Not Added":"Added"}</td>
                              <td> {g.Base_Fare}</td>
                              <td> {g.Base_KM}</td>
                              <td>{g.UptoPerKM}</td>
                              <td>{g.UptoBaseKM}</td>
                              <td>{g.Per_KM}</td>
                              <td>{g.VehicleTransactionFee}</td>
                              <td>{g.VehicleDiscount}</td>
                              <td>{g.RiderCommission}</td>
                              <td>{g.SearchDistance}</td>
                              <td>{g.VehicleDescription}</td>
                             
                              <td>{p.Tax}</td>
                              <td>{p.Penalty}</td>
                              <td>{p.Hike}</td>
                              <td>{p.MorningHike}</td>
                              <td>{p.EveningHike}</td>

                              <br />
                            </tr>
                          </Table>
                        </>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          {!pricing && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Add Pricing
            </Alert>
          )}
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Modal title
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">...</div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button type="button" class="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pickanddrop;
